export const news = [
    {
        id: 0,
        active: true,
        content: "AI sometimes is overloaded, please be patient"
    },{
        id: 1,
        active: true,
        content: "click [next round] to show next 5 songs"
    },{
        id: 2,
        active: true,
        content: "click song's name or image to listen it"
    }, {
        id: 3,
        active: true,
        content: "click artist's name to show artist mode"
    }, {
        id: 4,
        active: true,
        content: "sign in to google can save your likes"
    }
];